import { createSlice } from '@reduxjs/toolkit';
import {set} from 'lodash'
export const currentJobSlice = createSlice({
  name: 'entryLineDetail',
  initialState:{
    currentJob: {}
  },
  reducers: {
    initalizeCurrentJob: (state, {payload}) => {
        state.currentJob = payload
    },
    updateCurrentJob: (state, {payload}) => {
      state.currentJob = {...state.currentJob, ...payload}
    }
  }
});

export const { initalizeCurrentJob, updateCurrentJob } = currentJobSlice.actions;

export default currentJobSlice.reducer;
